import $ from 'jquery';

var DefaultPageCollection = require('base/collections/page');

import ContactGroup from 'base/models/contactgroup';

let GroupsCollection = DefaultPageCollection.extend({
    constructor(models, options){
        this.options = { filter: options.filter };
        this.urlBase = '/names-filter/' + options.filter + '/groups/';
        DefaultPageCollection.apply(this, arguments);  
    },

    urlBase: '/names-filter/groups/',
    queryParams:{
        totalRecords: null,
        totalPages: null,
        offset() { return (this.state.currentPage-1) * this.state.pageSize; },
        limit() { return this.state.pageSize; }
    },
    model: ContactGroup,
    _prepareModel(){
        let model = DefaultPageCollection.prototype._prepareModel.apply(this, arguments);
        model.options.filter = this.options.filter;
        return model;
    },

    /**
     * Request Joinos Code Letters to be produced for the contact groups
     * contained within this collection
     */
    createJoinosCodeLetters(cb){
        $.post('/joinos/joinos_codes/letters/?format=json', {
            groups: this.map((item) => {
                return item.get('id');
            })
        }, cb);
    }
});

export default GroupsCollection;



// WEBPACK FOOTER //
// ./base/collections/contacts/groups.js